module.exports = __webpack_public_path__ + "img/profilfoto_jan_manemann.b6909bda.png";